import { configureStore } from "@reduxjs/toolkit";
import navigationReducer from "./navigationSlice";
import agentsReducer from "./agentsSlice";
import conversationsReducer from "./conversationsSlice";
import uiReducer from "./uiSlice";
import authReducer from "@/features/auth/authSlice";

export const store = configureStore({
  reducer: {
    navigation: navigationReducer,
    agents: agentsReducer,
    conversations: conversationsReducer,
    ui: uiReducer,
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
